<template>
  <div>
    <div class="d-f jc-c ai-fe gap10">
      <input type="text" :name="`${propName}_year`" v-model="yearValue" :maxlength="4" size="4" class="u-input-text js-numOnly" :class="{ 'u-input-disabled': !!ongoingValue }" :placeholder="propOptions.example" @input="sanitize('yearValue', 4)" :disabled="ongoingValue">
      <span class="fz135 fw-b">年</span>
      <input type="text" :name="`${propName}_month`" v-model="monthValue" :maxlength="2" size="2" class="u-input-text js-numOnly" :class="{ 'u-input-disabled': !!ongoingValue }" :placeholder="propOptions.example" @input="sanitize('monthValue', 2)" :disabled="ongoingValue">
      <span class="fz135 fw-b">月</span>
    </div>
    <div v-if="propOptions.show_ongoing" class="d-f ai-c gap10 mt5">
      <label>
        <input type="checkbox" :name="`${propName}_ongoing`" class="u-input-checkBox" v-model="ongoingValue" @change="handleOngoingChange" value="1">
        <span>現在も継続中</span>
      </label>
    </div>
    <p class="c-red" v-for="error in errors">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    propName: String,
    propValue: {
      type: Object,
      default: () => ({}),
    },
    propOptions: {
      type: Object,
      default: () => ({}),
    },
    propOptional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      yearValue: '',
      monthValue: '',
      ongoingValue: false,
      debounceTimer: null,
      lastEmitted: null,
      errors: [],
    }
  },
  created() {
    const year = this.propValue?.year;
    const month = this.propValue?.month;
    this.yearValue = year != null ? String(year) : '';
    this.monthValue = month != null ? String(month).padStart(2, '0') : '';
    this.ongoingValue = !!this.propValue?.ongoing;
  },
  mounted() {
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  },
  methods: {
    sanitize(field, maxLen) {
      this[field] = this[field]
        .replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
        .replace(/[^0-9]/g, '')
        .slice(0, maxLen);
      this.handleInput();
    },
    getErrors() {
      if (this.ongoingValue) return [];
      const errors = [];
      const yearVal = String(this.yearValue || '').trim();
      const monthVal = String(this.monthValue || '').trim();
      if (this.propOptional && yearVal === '' && monthVal === '') return [];
      if (yearVal.length < 4) {
        errors.push('年は4桁で入力してください');
      }
      if (monthVal.length < 2) {
        errors.push('月は2桁で入力してください');
      } else {
        const monthNum = Number(monthVal);
        if (monthNum < 1 || monthNum > 12) {
          errors.push('月は01〜12の範囲で入力してください');
        }
      }
      return errors;
    },
    handleOngoingChange() {
      this.errors = [];
      this.handleInput();
    },
    handleInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.errors = this.getErrors();
        const event = this.errors.length === 0 ? 'valid' : 'invalid';
        if (event !== this.lastEmitted) {
          this.lastEmitted = event;
          this.$emit(event);
        }
      }, 300);
    },
    validate() {
      const event = this.getErrors().length === 0 ? 'valid' : 'invalid';
      this.lastEmitted = event;
      this.$emit(event);
    }
  }
}
</script>
